"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireDefault(require("react"));
var _click = _interopRequireDefault(require("../click"));
var _classNames = _interopRequireDefault(require("../classNames"));
var _Signature = _interopRequireDefault(require("../Signature"));
var _canvasToBlob = _interopRequireDefault(require("../canvasToBlob"));
var _dialog = _interopRequireDefault(require("../Modal/dialog"));
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/InputSignature/index.js";
function InputSignature(_ref) {
  var className = _ref.className,
    field = _ref.field,
    object = _ref.object,
    save = _ref.save;
  var canvasRef = _react["default"].useRef(null);
  var _React$useState = _react["default"].useState(0),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    progress = _React$useState2[0],
    setProgress = _React$useState2[1];
  var _React$useState3 = _react["default"].useState(null),
    _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
    image = _React$useState4[0],
    setImage = _React$useState4[1];
  var value = object[field];
  function readImage(file) {
    var reader = new FileReader();
    reader.onload = function (e) {
      setImage(e.target.result);
    };
    reader.readAsDataURL(file);
  }
  function onFileSelected(file) {
    readImage(file);
    var options = {
      progress: function progress(value) {
        return setProgress(value * 100);
      }
    };
    save.execute(file, options).then(function (result) {
      object[field] = result.url;
      setImage(result.url);
      setProgress(0);
    })["catch"](function (error) {
      console.log('error', error);
    });
  }
  function onClick() {
    var input = document.createElement('input');
    input.type = "file";
    input.accept = 'img';
    input.onchange = function (e) {
      var _e$target$files = (0, _slicedToArray2["default"])(e.target.files, 1),
        file = _e$target$files[0];
      file && onFileSelected(file);
    };
    (0, _click["default"])(input);
  }
  function pinClick(e) {
    e.stopPropagation();
    _dialog["default"].fire({
      html: /*#__PURE__*/_react["default"].createElement(_Signature["default"], {
        setRef: canvasRef,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 55,
          columnNumber: 21
        }
      }),
      positiveButton: 'SAVE',
      onPositiveClick: function onPositiveClick() {
        var dataURL = canvasRef.current.toDataURL('image/png');
        var canvas = canvasRef.current;
        setImage(dataURL);
        var options = {
          progress: function progress(value) {
            return setProgress(value * 100);
          }
        };
        (0, _canvasToBlob["default"])(canvas, 'signature', 'image/png').then(function (blob) {
          return save.execute(blob, options);
        }).then(function (result) {
          console.log(result.url);
          object[field] = result.url;
          setImage(result.url);
          setProgress(0);
        })["catch"](function (error) {
          console.log('error', error);
        });
      }
    });
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    onClick: onClick,
    className: (0, _classNames["default"])("rounded bg-light position-relative cursor-", className),
    style: {
      height: "250px"
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 85,
      columnNumber: 9
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "position-absolute h-100 w-100 d-flex",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 89,
      columnNumber: 13
    }
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: "w-100 h-100 m-auto",
    src: image || value,
    style: {
      objectFit: "cover"
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 91,
      columnNumber: 17
    }
  })), !(image || value) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "position-absolute h-100 w-100 d-flex",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 95,
      columnNumber: 21
    }
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "bi bi-camera-fill display-3 text-dark m-auto",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 96,
      columnNumber: 25
    }
  })), progress > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "position-absolute h-100 w-100 bg-black bg-opacity-50",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 101,
      columnNumber: 33
    }
  }), progress > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "position-absolute h-100 w-100 d-flex",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 105,
      columnNumber: 21
    }
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: "m-auto text-white",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 106,
      columnNumber: 25
    }
  }, progress.toFixed(0), "%")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "position-absolute w-100 text-end",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 110,
      columnNumber: 13
    }
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    onClick: pinClick,
    className: "btn btn-secondary",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 111,
      columnNumber: 17
    }
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "bi bi-pencil",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 114,
      columnNumber: 51
    }
  }))));
}
var _default = InputSignature;
exports["default"] = _default;